module.exports = __webpack_public_path__ + "img/ae8b484.jpg";